module.exports = __webpack_public_path__ + "static/media/homepage-03.60e53a01.png";